import { usePagesQuery } from '@/__generated_graphql__/types';
import { PagesSummary } from '@/components/PageRenderer/PageRenderer.types';

export const STATIC_SLUGS_ORDER = [
  'listing-guidelines',
  'terms-conditions',
  'privacy-policy',
  'advertising'
] as const;

export const useStaticPages = () => {
  const { data } = usePagesQuery();

  const pages: PagesSummary = (data?.pages ?? []).map(page => ({
    slug: page.slug,
    title: page.title,
    href: `/pages/${page.slug}`
  }));

  const burgerMenuSlugOrder = new Map<string, number>(
    STATIC_SLUGS_ORDER.map((slug, index) => [slug, index])
  );

  const filteredBurgerMenuPages = pages.sort(
    (a, b) =>
      burgerMenuSlugOrder.get(a.slug)! - burgerMenuSlugOrder.get(b.slug)!
  );

  return { pages: filteredBurgerMenuPages };
};
